import { render, staticRenderFns } from "./PolicyData.vue?vue&type=template&id=975f05a8"
import script from "./PolicyData.vue?vue&type=script&lang=js"
export * from "./PolicyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports